// Reference(s) taken from lodash

export function cloneDeep(object) {
    // eslint-disable-next-line no-undef
    return structuredClone(object);
}

/**
 * check if both object are equal or similar result
 * @param a
 * @param b
 * @returns {boolean}
 */
export function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null) return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
        if (!keysB.includes(key) || !deepEqual(a[key], b[key])) return false;
    }

    return true;
}

export function omitKeys(obj, keys = []) {
    if (obj === null || typeof obj !== 'object') return obj;

    function buildOmitMap(keys) {
        const map = {};
        for (const key of keys) {
            const parts = key.split('.');
            let current = map;
            for (let i = 0; i < parts.length; i++) {
                const part = parts[i];
                if (i === parts.length - 1) {
                    current[part] = true;
                } else {
                    current[part] = current[part] || {};
                    current = current[part];
                }
            }
        }
        return map;
    }

    const omitMap = buildOmitMap(keys);

    function omit(obj, omitMap) {
        if (obj === null || typeof obj !== 'object') return obj;
        const result = Array.isArray(obj) ? [] : {};

        for (const [key, value] of Object.entries(obj)) {
            if (omitMap[key] === true) {
                // omit this key entirely
                continue;
            } else if (typeof omitMap[key] === 'object') {
                // nested omit, recurse
                result[key] = omit(value, omitMap[key]);
            } else {
                // not omitted, copy as is
                result[key] = value;
            }
        }

        return result;
    }

    return omit(obj, omitMap);
}


/**
 * get object by selected keys
 * @param obj
 * @param keys
 * @returns {{}}
 */
export function pickKeys(obj, keys = []) {
    if (obj === null || typeof obj !== 'object') return {};

    // Helper to get nested value safely
    function getNestedValue(obj, path) {
        return path.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj);
    }

    // Build the picked object with nested structure
    const result = {};

    for (const key of keys) {
        const value = getNestedValue(obj, key);
        if (value !== undefined) {
            const parts = key.split('.');
            let current = result;
            for (let i = 0; i < parts.length; i++) {
                const part = parts[i];
                if (i === parts.length - 1) {
                    current[part] = value;
                } else {
                    if (!current[part] || typeof current[part] !== 'object') {
                        current[part] = {};
                    }
                    current = current[part];
                }
            }
        }
    }

    return result;

}
